// @flow

import React from 'react'
import { compose } from 'recompose'
import { Trans, withI18n } from '@lingui/react'

import withStyles from 'material-ui/styles/withStyles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'

import Section from 'components/Section'
import Map, { mapUrl } from 'components/Map'

type Props = {
  classes: Object,
  i18n: Object,
}

const KontaktSection = ({ classes, i18n }: Props) => (
  <Section className={classes.root} anchor={i18n._('kontakt.slug')}>
    <Map
      googleMapURL={mapUrl}
      loadingElement={<div className={classes.mapLoading} />}
      containerElement={<div className={classes.mapContainer} />}
      mapElement={<div className={classes.map} />}
    />
    <Grid className={classes.footer} container spacing={0}>
      <Grid item xs={12} sm={5} md={4} lg={3}>
        <Typography className={classes.list} component={'ul'}>
          <Typography component={'li'}>
            <Trans id='kontakt.company' />
          </Typography>
          <Typography component={'li'}>
            <Trans id='kontakt.address1' />
          </Typography>
          <Typography component={'li'}>
            <Trans id='kontakt.address2' />
          </Typography>
          <Typography component={'li'}>
            <Trans id='kontakt.country' />
          </Typography>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={3}>
        <Typography className={classes.list} component={'ul'}>
          <Typography component={'li'}>
            <a href={'tel:0038640831798'}>{'+386 40 831 798'}</a>
          </Typography>
          <Typography component={'li'}>
            <a href={'mailto:danaja.oblak@preset.si'}>{'danaja.oblak@preset.si'}</a>
          </Typography>
        </Typography>
      </Grid>
      <Grid className={classes.company} item xs={12} sm={3} md={4} lg={6}>
        <Typography className={classes.preset}>{'Preset'}</Typography>
        <Typography className={classes.copyright}>
          {`© ${new Date().getFullYear()} Preset d.o.o.`}
        </Typography>
      </Grid>
    </Grid>
  </Section>
)

const styles = theme => ({
  root: {
    color: '#f9f9f9',
    backgroundColor: '#333333',
    padding: '0',
  },
  mapLoading: {
    width: '100%',
    flex: '1',
  },
  mapContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    flex: '1',
  },
  map: {
    position: 'absolute !important',
    height: '100%',
    width: '100%',
  },
  footer: {
    padding: `${theme.spacing.unit * 3}px`,
  },
  list: {
    margin: '0',
    marginBottom: theme.spacing.unit * 3,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    paddingLeft: theme.spacing.unit,
    color: 'inherit',
    '& li': {
      textAlign: 'left',
      color: 'inherit',
      '& a': {
        color: 'inherit',
        textDecoration: 'none',
        '&:hover': {
          color: 'rgba(255,255,255,0.7)',
        },
      },
    },
  },
  preset: {
    display: 'inline-block',
    flex: '1',
    font: '0/0 a',
    color: 'transparent',
    border: '2px solid #808080',
    width: '145px',
    height: '48px',
    borderRadius: '0',
    textAlign: 'center',
    padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit * 3}px`,
    marginBottom: theme.spacing.unit * 2,
    backgroundImage: `url(${require('./images/logo-gray.svg')})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '104px 26px',
  },
  copyright: {
    color: '#808080',
    fontSize: '1rem',
  },
  [theme.breakpoints.up('sm')]: {
    list: {
      marginBottom: '0',
    },
    company: {
      textAlign: 'right',
    },
  },
  [theme.breakpoints.up('md')]: {
    footer: {
      padding: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 9}px`,
    },
  },
})

export default compose(
  withI18n(),
  withStyles(styles),
)(KontaktSection)



// WEBPACK FOOTER //
// ./src/components/Kontakt/index.js